import { IScopeClause, IScopeClauseClause } from "@/api/scopes/scopes.types";

export type ResolvedOrganizationClauseGuidance =
    | {
          guidance: string;
          source: "organization";
          own: NonNullable<IScopeClauseClause["organization_clause_guidance"]>;
      }
    | {
          guidance: string;
          source: "inherited_from_group";
          sharedByOrganizationName: string;
      }
    | { guidance: string; source: "default" };

export type ResolvedClauseGuidance =
    | ResolvedOrganizationClauseGuidance
    | { guidance: string; source: "scope" };

export type ClauseGuidanceSource = ResolvedClauseGuidance["source"];

export const resolveOrganizationClauseGuidance = (
    clause: IScopeClauseClause
): ResolvedOrganizationClauseGuidance => {
    const own = clause.organization_clause_guidance;
    if (own?.guidance.trim()) {
        return {
            guidance: own.guidance,
            source: "organization",
            own,
        };
    }

    const inherited = clause.inherited_guidance;
    if (inherited?.guidance.trim()) {
        return {
            guidance: inherited.guidance,
            source: "inherited_from_group",
            sharedByOrganizationName: inherited.shared_by_organization_name,
        };
    }

    return {
        guidance: clause.guidance || "",
        source: "default",
    };
};

export const resolveClauseGuidanceWithSource = (
    input: IScopeClause
): ResolvedClauseGuidance => {
    if (input.guidance?.trim()) {
        return {
            guidance: input.guidance,
            source: "scope",
        };
    }

    return resolveOrganizationClauseGuidance(input.clause);
};

export const resolveClauseGuidance = (input: IScopeClause): string =>
    resolveClauseGuidanceWithSource(input).guidance;
